import { tt } from './i18n'

/**
 * Whether the scheduler runs on this installation, and what to say when it does not - owner question #80,
 * `FRONTEND.md` §9.533, `BACKEND.md` §10A.278.
 *
 * **Every screen that reports a scheduled job's state could only say it never ran.** `agos.jobs.enabled` was
 * read by exactly two `@ConditionalOnProperty` annotations, so production pinning `AGOS_JOBS_ENABLED=false`
 * left the backup screen truthfully reporting *"Úloha zálohovania sa zatiaľ nespustila ani raz"* with no way
 * for the owner to tell that from *backups are broken*. §10A.278 puts the flag on the read that is already
 * being asked when the job last ran.
 */

/**
 * The sentence for a scheduler that is switched off, or null.
 *
 * **Explicitly `false` only, and an absent field answers null.** A server older than §10A.278 does not send
 * this, and inventing *jobs are off* from a missing field would be §9.532's defect with the sides swapped -
 * a claim manufactured from the absence of an answer. `undefined` and `null` therefore mean *not known*, and
 * a screen that knows nothing says nothing.
 */
export function scheduledJobsOffNote(enabled: unknown): string | null {
  if (enabled !== false) return null
  return tt(
    'Naplánované úlohy sú na tejto inštalácii vypnuté, takže sa nespustí ani táto - nie je to porucha. Zapína sa to pri prechode na AGOS.',
  )
}
